import { Button, CircularProgress, TextField } from "@mui/material";
import React, { useState } from "react";
import { MdClose } from "react-icons/md";
import { useNotify } from "../../../context/NotifyContext";
import { formatAmount } from "../../../utils/formatAmount";

const MiniStatementPopup = ({ details, close, onSubmitAmount, loading }) => {
  const [amount, setAmount] = useState("");
  const { notify } = useNotify(); // ✅ initialize notify

  const handleSubmit = () => {
    const enteredAmount = Number(amount);
    const availableAmount = Number(details?.balanceamount || 0);

    // ✅ Validate amount
    if (!enteredAmount || isNaN(enteredAmount) || enteredAmount <= 0) {
      notify("Please enter a valid positive amount", "error");
      return;
    }

    if (enteredAmount > availableAmount) {
      notify("Entered amount cannot exceed available balance", "error");
      return;
    }

    // ✅ Call parent callback with valid amount
    onSubmitAmount(enteredAmount);
  };



  return (
    <div className="bg-white dark:bg-slate-800 shadow-md border rounded-lg p-4 w-full max-w-sm">
      <div className="flex justify-between items-center mb-3">
        <h2 className="text-lg font-semibold">Balance Details</h2>
        <MdClose className="cursor-pointer" onClick={close} />
      </div>

      <div className="space-y-2 text-sm">
        <Row label="Message" value={details?.message} />
        <Row label="Status" value={details?.status ? "SUCCESS" : "FAILED"} />
        <Row label="Ack No" value={details?.ackno} />
        <Row label="Bank RRN" value={details?.bankrrn} />
        <Row label="Bank IIN" value={details?.bankiin} />
        <Row label="Mobile" value={details?.mobile || "-"} />

        <div className="flex justify-between border-t pt-2 mt-2">
          <span className="font-semibold">Available Balance</span>
          <span className="font-bold text-green-600">
            ₹ {formatAmount(details?.balanceamount) || "0.00"}
          </span>
        </div>
      </div>

      {/* 👇 Amount Input + Submit */}
      <div className="flex gap-2 mt-4">
<input
  type="number"
  placeholder="Enter Amount"
  value={amount}
  onChange={(e) => {
    const val = e.target.value;

    // empty allow (user delete kar sake)
    if (val === "") {
      setAmount("");
      return;
    }

    const num = Number(val);
    const available = Number(details?.balanceamount || 0);

    // ❌ negative / zero
    if (num <= 0) return;

    // ❌ greater than available balance
    if (num > available) return;

    setAmount(val); // ✅ only valid value set
  }}
  min="1"
  step="1"
  className="border rounded px-2 py-1 w-full text-sm"
/>


     <Button
       onClick={handleSubmit}
              type="submit"
              fullWidth
              variant="contained"
              disabled={loading}
              sx={{
                backgroundColor: "#",
                padding: "10px",
                borderRadius: "8px",
              }}
            >
              {loading ? (
                <CircularProgress size={22} color="inherit" />
              ) : (
                "Submit"
              )}
            </Button>


        {/* <button
        
          className="bg-blue-600 text-white px-4 rounded text-sm"
        >
          Submit
        </button> */}
      </div>
    </div>
  );
};

const Row = ({ label, value }) => (
  <div className="flex justify-between">
    <span>{label}</span>
    <span className="font-medium">{value ?? "-"}</span>
  </div>
);

export default MiniStatementPopup;
